import { useProperty } from '@eti/providers';

const useTaxFormSection = (isPanAndDoBDisabled: boolean) => {
  const { p } = useProperty();

  const isTaxFormSectionDecoupled = p('Payment.TaxIdFeature.Decoupled.Enabled');
  const taxIdLabel = p('Payment.TaxIdFeature.Label');
  const shouldShowTaxFormSection =
    (!isPanAndDoBDisabled && Boolean(taxIdLabel)) || p('Payment.State.Enabled');

  return { shouldShowTaxFormSection, isTaxFormSectionDecoupled };
};

export const useTaxFormSectionForPaymentPage = (isPanAndDoBDisabled: boolean) => {
  const response = useTaxFormSection(isPanAndDoBDisabled);

  return {
    ...response,
    shouldShowTaxFormSection:
      response.shouldShowTaxFormSection && response.isTaxFormSectionDecoupled,
  };
};

export const useTaxFormSectionForPaymentMethod = (isPanAndDoBDisabled: boolean) => {
  const response = useTaxFormSection(isPanAndDoBDisabled);

  return {
    ...response,
    shouldShowTaxFormSection:
      response.shouldShowTaxFormSection && !response.isTaxFormSectionDecoupled,
  };
};
